import { Link } from "react-router-dom";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { pathConstants } from "../../../../routes/pathContants";
import { AngleRight, ExpenseOptionIcon } from "../../../../assets/svgIcons";

export const ExpenseCreationType = ({ navigateToSingleExpense = () => {} }) => {
  return (
    <div className={globalStyles.pageColumnGaps} style={{ gap: "15px" }}>
      <Link
        className={`${globalStyles.cardWithBorder} ${globalStyles.noTextDecoration} flex-row justify-content-between align-items-center`}
        onClick={() => navigateToSingleExpense()}
      >
        <div className="d-flex">
          <ExpenseOptionIcon className="mr-2" />
          <div>
            <h5 className="mb-1">Single Expense</h5>
            <p>Create expenses one-by-one</p>
          </div>
        </div>

        <AngleRight />
      </Link>

      <Link
        className={`${globalStyles.cardWithBorder} ${globalStyles.noTextDecoration} flex-row justify-content-between align-items-center`}
        to={pathConstants.EXPENSES_BULK_CREATE}
      >
        <div className="d-flex">
          <ExpenseOptionIcon className="mr-2" />
          <div>
            <h5 className="mb-1">Bulk Expense</h5>
            <p>Create multiple expenses at once</p>
          </div>
        </div>

        <AngleRight />
      </Link>
    </div>
  );
};
